import type {UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {Switch} from '@/components/ui/switch';
import {Textarea} from '@/components/ui/textarea';

import type {ResidentMedicationBasicFormValues} from '../../utils/medicationFormInputs';

export type MedicationNotesFieldsProps = {
  form: UseFormReturn<ResidentMedicationBasicFormValues>;
};

function MedicationNotesFields({form}: MedicationNotesFieldsProps) {
  const {t} = useTranslation();

  return (
    <>
      <FormField
        control={form.control}
        name="warnings"
        render={({field}) => (
          <FormItem>
            <FormLabel>{t('Warnings')}</FormLabel>
            <FormControl>
              <Textarea {...field} placeholder={t('e.g. Do not crush')} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="notes"
        render={({field}) => (
          <FormItem>
            <FormLabel>{t('Notes')}</FormLabel>
            <FormControl>
              <Textarea {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="showForDistribution"
        render={({field}) => (
          <FormItem className="flex flex-row items-center justify-between gap-4">
            <FormLabel>{t('Show for distribution')}</FormLabel>
            <FormControl>
              <Switch checked={field.value} onCheckedChange={field.onChange} />
            </FormControl>
          </FormItem>
        )}
      />
    </>
  );
}

export default MedicationNotesFields;
